import React from 'react';
import { Tag, Typography } from 'antd';
import { getWrittenSyncInstructions } from '../utils/syncProtocolUtils';
import '../styles/sync-protocol.css';

const { Text, Paragraph } = Typography;

export default function SyncProtocolWrittenGuide({ syncData, compact = false }) {
  const lines = getWrittenSyncInstructions(syncData);

  if (!lines.length) return null;

  return (
    <div className={`sync-written-guide${compact ? ' sync-written-guide--compact' : ''}`}>
      {!compact && (
        <>
          <Text strong className="sync-written-guide-title">Step-by-step field guide</Text>
          <Text type="secondary" className="sync-written-guide-intro">
            Take this list to the barn or paddock. Complete each item on the scheduled date and time, then mark Done in the schedule above.
          </Text>
        </>
      )}

      <ol className="sync-written-guide-list">
        {lines.map((line) => (
          <li
            key={line.stepNumber}
            className={`sync-written-guide-item${line.status === 'done' ? ' is-done' : ''}${line.isInsemination ? ' is-insemination' : ''}`}
          >
            <div className="sync-written-guide-item-head">
              <Tag color={line.status === 'done' ? 'success' : line.isInsemination ? 'green' : 'processing'}>
                {line.status === 'done' ? 'Done' : line.isInsemination ? 'AI step' : `Step ${line.stepNumber}`}
              </Tag>
              <Text strong className="sync-written-guide-heading">{line.heading}</Text>
            </div>

            <Text className="sync-written-guide-title-line">{line.title}</Text>
            <Paragraph className="sync-written-guide-action">{line.actionLine}</Paragraph>

            {line.products && (
              <Text type="secondary" className="sync-written-guide-products">
                Example products: {line.products}
              </Text>
            )}

            {line.instructions && (
              <Text className="sync-written-guide-detail">{line.instructions}</Text>
            )}

            {line.notes && (
              <Text type="secondary" className="sync-written-guide-notes">
                Notes: {line.notes}
              </Text>
            )}
          </li>
        ))}
      </ol>
    </div>
  );
}
